import { render, staticRenderFns } from "./StatementData.vue?vue&type=template&id=52e98d1e&scoped=true&"
import script from "./StatementData.vue?vue&type=script&lang=js&"
export * from "./StatementData.vue?vue&type=script&lang=js&"
import style0 from "./StatementData.vue?vue&type=style&index=0&id=52e98d1e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52e98d1e",
  null
  
)

export default component.exports